export default "__VITE_ASSET__Sir7K6GA__"